import React from 'react'

function HeightStats(teams) {


  const getHeightStats = () => {
    return teams.teams.map(team => ({
      nameText: team.name + '&nbsp; <img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      name: '<img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      value: getAverageHeight(team.players)
    })).sort((a, b) => b.value - a.value);
  }

  const getAverageHeight = players => {
    if (players === undefined || players.length === 0) return 0
    const totalHeight = players.reduce((sum, player) => {
      return sum + Number(player.height)
    }, 0)
    const averageHeight = totalHeight / players.length;
    return averageHeight.toFixed(2)
  }

  return (
    <div>
      <table className="table-stats">
        <thead>
          <tr>
            <th>Equipo</th>
            <th>Altura media</th>
          </tr>
        </thead>
        <tbody>
        {getHeightStats().map((item, index) => (
          <tr key={index}>
            <td><div className="label-team" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.value} m</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  )
}

export default HeightStats